import { render, staticRenderFns } from "./iframe-layout.vue?vue&type=template&id=6c292a10"
import script from "./iframe-layout.vue?vue&type=script&lang=js"
export * from "./iframe-layout.vue?vue&type=script&lang=js"
import style0 from "./iframe-layout.vue?vue&type=style&index=0&id=6c292a10&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports